import type transform from '../to/configurations';

export default (configurations: ReturnType<typeof transform>) => {
  if (configurations.length != new Set(configurations.map(x => x.id)).size)
    throw new Error('(Core::From::V2::Configurations) Configuration array have two or more configurations with the same ID');

  return configurations
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::Configurations) Configuration id is undefined');

      return { ...x };
    });
};
